<template>
    <div class="image-view">
        <b-img thumbnail :src="photoSrc" :width="width" :height="height" />
    </div>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import DummyImage from "@/assets/images/dummy_image.png";

const FilesApi = ApiFactory.get("files");

export default {
    name: "ImageView",
    props: {
        src: {
            type: [String, Number],
            default: null
        },
        width: {
            type: Number,
            default: 150
        },
        height: {
            type: Number,
            default: 150
        }
    },
    data() {
        return {
            image: null
        };
    },
    computed: {
        photoSrc() {
            if (this.image) {
                return this.image;
            } else {
                return DummyImage;
            }
        }
    },
    watch: {
        src: {
            handler(value) {
                this.downloadImage(value);
            },
            immediate: true
        }
    },
    methods: {
        async downloadImage(id) {
            if (id) {
                const response = await FilesApi.getFile(id, {
                    width: this.width,
                    height: this.height,
                    cropped: 1,
                    quality: 70
                });
                if (response.ok) {
                    this.image = URL.createObjectURL(response.blob);
                }
            }
        }
    }
};
</script>
